var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreatChat16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13612 4.80008H3.13333V12.6001H12.2V8.14261L13.3333 7.00928V12.6001C13.3333 13.2234 12.8233 13.7334 12.2 13.7334H3C2.44772 13.7334 2 13.2857 2 12.7334V4.80008C2 4.17675 2.51 3.66675 3.13333 3.66675H10.2695L9.13612 4.80008Z",
    fill: "#2767A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23009 8.43004L7 10L8.56997 9.89177L13.5597 4.90203L12.2198 3.4403L7.23009 8.43004ZM14.868 3.59369C15.044 3.41774 15.044 3.13351 14.868 2.95756L14.1643 2.13196C13.9883 1.95601 13.7041 1.95601 13.5282 2.13196L12.7025 2.95757L14.0424 4.41929L14.868 3.59369Z",
    fill: "#2767A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatChat16);
export default __webpack_public_path__ + "static/media/CreatChat16.1df6f1673dfba3912931269fca9af467.svg";
export { ForwardRef as ReactComponent };